import { gql } from 'apollo-angular';
import { Group } from '../../entities/group/group';
import { Tenant } from '../../entities/tenant/tenant';
import { User } from '../../entities/user/user';


export const USERS_QUERY = gql`
query getuserQuery(
  $id: UUID
)
{
  user: getUser(
    userId: $id
  )
  {
    id
    email
    enabled
    firstName
    lastName
    roles{
      name
      label
      isInherited
      inheritedFrom {
        name
      }
    }
    groups{
      name
      id
      roles
    }
    initials
    externalId
    requiredActions
    locationIds
    licenceType
  },
  roles: getRoles {
    name
    label
  }
  locations: getFrameworkLocations {
    name
    id
  }
  groups: getGroups{
    id
    name
    roles
  }
  licenceInfo: getLicenceInfos {
    type
    open
    assignable
  }
}
`;

export interface UserQueryResponse {
  user: User;
  roles: string[];
  loading: boolean;
  groups: Group[];
  locations: any[];
  licenceInfo: any[];
  tenant: Tenant;
}
